export default __webpack_public_path__ + "static/media/etcd.fbb67942.svg";